export default {
      id: "cti-usage",
      viewBox: "0 0 100 27",
      url: "assets/" + "sprite.svg#cti-usage",
      toString: function () {
        return this.url;
      }
    }